module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Dateien","no-attachments-found":"Es wurden keine Dateien gefunden"},"fr":{"no-attachments-found":"Aucun fichier trouvé","title":"Fichiers"},"it":{"no-attachments-found":"Non sono stati trovati dati","title":"Dati"}}')
  delete Component.options._Ctor
}
